import { createFileRoute } from "@tanstack/react-router";
import { ServiceCardGrid, ServiceDetailSection } from "#/components/pages/services";
import { FinalCTA } from "#/components/pages/home";
import { PageHeader } from "#/components/shared/PageHeader";
import { SERVICES } from "#/lib/constants";
import { HEADER } from "#/lib/images";
import { getServicesPageSchema } from "#/lib/seo";

const TITLE = "Concrete Services in Delaware | Blue Rock Concrete";
const DESCRIPTION =
  "Eight core concrete services: driveways, patios, stamped & decorative, walkways, steps & retaining walls, slabs, repair & resurfacing, and epoxy floors. Serving DE, PA & MD.";

export const Route = createFileRoute("/services")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "https://bluerockconcreteco.com/services" },
    ],
    links: [{ rel: "canonical", href: "https://bluerockconcreteco.com/services" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(getServicesPageSchema()) },
    ],
  }),
  component: ServicesPage,
});

function ServicesPage() {
  return (
    <main>
      <PageHeader
        eyebrow="Our Services"
        title="Concrete for any application"
        intro="Driveways, patios, stamped finishes, walkways, steps, slabs, repairs, and epoxy floors. Residential and commercial, poured and finished by our own crew."
        image={HEADER.services.src}
        imageMobile={HEADER.services.mobile}
        imageAlt={HEADER.services.alt}
      />
      <ServiceCardGrid />
      {SERVICES.map((service, i) => (
        <ServiceDetailSection key={service.slug} service={service} index={i} />
      ))}
      <FinalCTA />
    </main>
  );
}
